/* eslint-disable @wix/da/window-object-typeof-check */
// with pushState/replaceState, document.referrer no longer works reliably
// thus, with this little helper we keep track of previous/current url for BI
var isSSR = typeof document === 'undefined' || typeof window === 'undefined';
var referrer = isSSR ? undefined : document.referrer;
var previousUrl = referrer;
var currentUrl = isSSR ? undefined : window.location.href;
export function updateReferrer() {
    if (isSSR || window.location.href === currentUrl) {
        return;
    }
    previousUrl = currentUrl;
    currentUrl = window.location.href;
}
export function commitReferrer() {
    referrer = previousUrl;
}
export function getReferrer() {
    return referrer;
}
//# sourceMappingURL=referrer.js.map